import * as types from '../actions/intl-actions';

let defaultLang = 'en-US';
try {
	defaultLang = navigator.language
} catch (e) {}

const initialState = {
	intl: {
		lang: defaultLang
	}
};

const intlReducer = function (state = initialState, action) {

	switch (action.type) {
		case types.CHANGE_INTL_SUCCESS:
			return Object.assign({}, state, {intl: {lang: action.lang}});
			break;
	}

	return state;
};

export default intlReducer;



// WEBPACK FOOTER //
// ./src/reducers/intl-reducer.js